export enum PromotionDetailsStep {
  Promotion = "promotion",
  Conditions = "conditions",
}
